var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"link btn btn-default ce-author-like-share__share-button flex-grow-1",attrs:{"href":this.fullUrl,"target":"_blank"}},[_vm._t("label",function(){return [_vm._v("Share Facebook")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }